import { SI_ROOT_ROUTE } from "app/pages/sales-intelligence/constants/routes";
import {
    TEAM_DETAIL_ROUTE,
    TEAM_DETAIL_URL,
    TEAMS_MANAGEMENT_ROUTE,
    TEAMS_MANAGEMENT_URL,
} from "app/pages/sales-intelligence/constants/sl_routes";
import { TeamDetailContainer } from "app/pages/sales-intelligence/pages/management/containers/TeamDetailContainer/TeamDetailContainer";
import { TeamsManagementContainer } from "app/pages/sales-intelligence/pages/management/containers/TeamsManagementContainer/TeamsManagementContainer";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import withSignalsManagement from "app/pages/sales-intelligence/sub-modules/signals/hoc/withSignalsManagement";
import type { SecondaryBarType } from "app/reducers/_reducers/SecondaryBarReducer";
import { fallback } from "app/routes/handlers/redirectFunctions/fallback";
import { redirectPipe } from "app/routes/handlers/redirectFunctions/redirectPipe";
import type { RouterStateConfig } from "single-spa/react-app/router/IRouterState";

const TeamDetailPage = withSignalsManagement(TeamDetailContainer);

export const teamsManageConfig: RouterStateConfig = {
    [TEAMS_MANAGEMENT_ROUTE]: {
        parent: SI_ROOT_ROUTE,
        url: TEAMS_MANAGEMENT_URL,
        configId: "SalesWorkspace",
        stateId: TEAMS_MANAGEMENT_ROUTE,
        component: TeamsManagementContainer,
        pageTitle: "si.pages.teams_management.document_title",
        trackingId: {
            section: "SI_admin",
            subSection: "teams",
            subSubSection: "teams management",
        },
        isSecondaryBarOpen: false,
        secondaryBarType: "None" as SecondaryBarType,
        redirectTo: redirectPipe(
            fallback({
                salesIntelligence: "salesIntelligence-home",
            }),
        ),
        isHidden: () => !salesSettingsHelper.isHighLevelAccount(),
    },
    [TEAM_DETAIL_ROUTE]: {
        parent: SI_ROOT_ROUTE,
        url: TEAM_DETAIL_URL,
        configId: "SalesWorkspace",
        stateId: TEAM_DETAIL_ROUTE,
        component: TeamDetailPage,
        pageTitle: "si.pages.teams_management.document_title",
        trackingId: {
            section: "SI_admin",
            subSection: "teams",
            subSubSection: "team detail",
        },
        isSecondaryBarOpen: false,
        secondaryBarType: "None" as SecondaryBarType,
        params: {
            id: { type: "int" },
            tab: { dynamic: true },
            isNewTeam: { dynamic: true },
        },
        redirectTo: redirectPipe(
            fallback({
                salesIntelligence: "salesIntelligence-home",
            }),
        ),
        isHidden: () => !salesSettingsHelper.isHighLevelAccount(),
    },
};
